import React, { useState, useContext } from "react";
import { TextField, Button, Box, Typography } from "@mui/material";
import { useUserContext } from "../providers/userProvider"; // Adjust the import path as necessary
import { updateProfile } from "firebase/auth";
import user from "firebase/auth"; // Import the firebase/auth module
import { useNavigate } from "react-router-dom";
function ProfilePage() {
  const { user } = useUserContext(); // Assuming UserContext is properly typed
  const navigate = useNavigate();
  const [newUsername, setNewUsername] = useState<string>(
    user?.displayName || ""
  );
  const [error, setError] = useState("");

  const handleUsernameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNewUsername(event.target.value);
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const currentUser = user; // Ensure `user` is the current authenticated user
    if (!newUsername) {
      setError("Username cannot be empty");
    }
    if (currentUser && newUsername) {
      // Check if `currentUser` and `newUsername` are truthy
      try {
        await updateProfile(currentUser, {
          displayName: newUsername,
        });
        // Assuming `setUser` is correctly set up for state management
        setUser({ ...user, displayName: newUsername }); // Use `displayName` if that's the correct field
        alert("Username updated successfully!");
      } catch (error) {
        console.error("Error updating username:", error);
        navigate("/");
      }
    }
  };

  return (
    <Box sx={{ width: "100%", maxWidth: 500, mx: "auto" }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Profile Page
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Username"
          variant="outlined"
          value={newUsername}
          onChange={handleUsernameChange}
          margin="normal"
        />
        {error && <Typography color="error">{error}</Typography>}
        <Button type="submit" variant="contained" color="primary">
          Update Username
        </Button>
      </form>
    </Box>
  );
}

export default ProfilePage;

function setUser(arg0: {
  displayName: string;
  emailVerified: boolean;
  isAnonymous: boolean;
  metadata: user.UserMetadata;
  providerData: user.UserInfo[];
  refreshToken: string;
  tenantId: string | null;
  delete(): Promise<void>;
  getIdToken(forceRefresh?: boolean | undefined): Promise<string>;
  getIdTokenResult(
    forceRefresh?: boolean | undefined
  ): Promise<user.IdTokenResult>;
  reload(): Promise<void>;
  toJSON(): object;
  email: string | null;
  phoneNumber: string | null;
  photoURL: string | null;
  providerId: string;
  uid: string;
}) {
  throw new Error("Function not implemented.");
}
